import {openLockSvg as Icon__small__openLockSvg} from '../Icon__small/Icon__small--openLock.js';

export var openLock = {
  name: 'openLock',
  category: 'icon',
  colorable: true,
  svg: Icon__small__openLockSvg,
};
